export enum ModuleType {
  Default = 0,
  Resource = 1,
  Document = 2,
}
